import React, { Component } from 'react'; 
import axios from '../../axios';
import * as url from '../../utils/url';
import Plot from "../../utils/customPlotly";
import moment from 'moment';


class UniqueActionOwners extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      actionCount:this.props.actionCount,
      isAllEOPage: this.props.eo_id==null? true: false,
    }

    //  console.log(this.props)
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.actionCount !== prevProps.actionCount) {
      this.getActionStats()
    }
  }

  
componentDidMount(){
  this.getActionStats()
}

  
getActionStats = ()=>{
    // console.log('called!')
    let params = {
        enterpriseId: this.props.eo_id
      }
      axios.get(url.getUniqueActionOwners, {
        params: params })
        .then( (result)=> {
        // console.log('data---',  result)
        let count = { ...result.data.data}
        this.setState({ count })   
      })
}



render() { 
    let{count, isAllEOPage}=this.state
    if( count && count.distinct ){
        return ( 
          <div className="enterpriseObjStatInt">
            {count.distinct}
            <p className='enterpriseObjSubtitle statsChildSubtitle'>of {count.total} users</p>
          </div>
        )
    } else if(!count || (count && count.distinct==0)){
      return (
        <span>
          <div className={isAllEOPage?'':'actionStatsNA'} > No users </div>
          <p className="actionStatsNAsubtitle"> with actions </p>
        </span>
        )
    } else{
      return <div className={isAllEOPage?'actionStatsNA mt14p':'actionStatsNA'} >Loading...</div>
    }
  }
}
 
export default UniqueActionOwners;